import React from 'react';
import UploadFileComponent from './UploadFileComponent';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';

class NewBrandComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            brandId: this.props.brandId || 0,
            name: this.props.name || '',
            address: this.props.address || '',
            phone: '',
            cellphone: ''
        };
    }

    _handleCreateBrand() {
        let { name, address, phone, cellphone } = this.state;
        this.setState({
            loading: true
        });
        TotemActions.addBrand(name, address, this.newBrandCallback.bind(this));
    }

    newBrandCallback() {
        this.setState({
            loading: false
        });
        this.props.brandSaved();
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            isValid: (this.state.name !== '')
        });
    }

    _onCancelModal() {
        this.setState({
            name: '',
            address: '',
            phone: '',
            cellphone: ''
        });
        this.props.cancelModal()
    }

    render() {

        return (
            <div id="createBrand" className="modal">
                <div className="modal-content">
                    <h5>Agregar nueva Sucursal</h5>
                    <div className="row">
                        <div className="input-field col s12 m6">
                            <input type="text" name="name" value={this.state.name} onChange={this._handleInputChange.bind(this)} />
                            <label htmlFor="name">Nombre de la nueva sucursal</label>
                        </div>
                        <div className="input-field col s12 m6">
                            <input type="text" name="address" value={this.state.address} onChange={this._handleInputChange.bind(this)} />
                            <label htmlFor="address">Dirección de la nueva sucursal</label>
                        </div>
                    </div>
                </div>
                <div className="modal-footer right-align">
                    <a className="waves-effect waves-light btn  red darken-4" onClick={this._onCancelModal.bind(this)}>Cancelar</a>
                    <a className={this.state.isValid ? 'waves-effect waves-light btn blue darken-3' : 'waves-effect waves-light btn blue darken-3 disabled'} onClick={this._handleCreateBrand.bind(this)}>Guardar</a>
                </div>
            </div>
        );
    }
}

export default NewBrandComponent;


// WEBPACK FOOTER //
// ./src/components/NewBrandComponent.js